// duplicate from gaming federation
// ideally it will be moved to types library and deleted here
export const CustomGamingRoutes = {
    MyCasinoLiveCasinoCategory: 'myCasinoLiveCasinoCategory',
} as const;

export type CustomGamingRoutes = typeof CustomGamingRoutes[keyof typeof CustomGamingRoutes];
